/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Alert/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Alert({
  children,
  viewPath = "/App/Account/Content/Content/Home/MessageAlert/Content/Content/Alert"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let isMedia = useIsMedia()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let constantData = 'You have a new message that needs attention for'
let threadAlertNameValueData = fromData.useDataValue({ viewPath,
context: 'thread_alert',
path: 'name',
})
let constantData1 = ' ✉️ !'
let aggregateData = fromAggregate.join(constantData, threadAlertNameValueData, constantData1)
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 marginLeft="auto"
 marginRight="auto"
 size={isMedia.mobile ? "small" : "large"}
 flexGrow={0}
 marginTop={dtSpaceS}
 backgroundColor={dtColorsWhite}
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
>
{childProps => (
<button
  data-testid="Alert.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mt-1-4z5bt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'You have a new message that needs attention for'"
 data="thread_alert.name"
 data="' ✉️ !'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</button>
)}
</TysiaCardContent>
)}
</TysiaCard>
{children}
</React.Fragment>)
}